export const LOGIN = '/Authentication/Login';
export const SIGN_UP = '/Authentication/SignUp';
export const LANDING = '/';
export const HOME = '/Authentication/UserHome';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const CARDS = '/Cards';
export const DECKS = '/Decks';
export const DECKBUILDER = 'DeckBuilder';
export const GRIMM = "/Articles/GrimmInterview";
export const ARTICLECOLLECTION = "/ArticleCollection";
export const OPEN = "/Articles/OpenForBusiness";
export const DECKBUILDERV2 = "/DBV2/DeckbuilderV2";
export const DECKVIEW = "/DBV2/DeckView/";
export const DECKSLIVE = "/Articles/DeckBuildingLive";
export const BOSSINTERVIEW = "/Articles/BossryutsuInterview";
export const TOURNAMENTGRID = "/Tournaments/TournamentGrid";
export const TOURNAMENT = "/Tournaments/Tournament/";
export const FRIDAYBLITZ = "/Articles/FridayBlitz";
export const DECKSELECT = "/Tournaments/DeckSelect";
export const ARCHONBOMB = "/Articles/ArchonBomb";
export const FRIDAY1 = "/Articles/Friday1";
export const FRIDAY2 = "/Articles/Friday2";
export const LEADERBOARD = "/LeaderBoard/Rankings";
export const FRIDAY3 = "/Articles/Friday3";
export const ARTICLEBASE = "/Articles/ArticleBase/";
export const PARCHMENT = "/Admin/Parchment";



// WEBPACK FOOTER //
// ./src/Constants/routes.js